/* global $:false */

import htmx from 'htmx.org/dist/htmx.js'

export default class AppBoost {
  start() {
    if (window.webkit?.messageHandlers?.htmxLoad) {
      htmx.on('htmx:xhr:loadstart', (e) => {
        this._appCalloutLoadState(true)
      })

      htmx.on('htmx:xhr:loadend', (e) => {
        this._appCalloutLoadState(false)
      })
    }
  }

  _appCalloutLoadState(state) {
    window.webkit.messageHandlers.htmxLoad.postMessage({'load': state})
  }
}
